import angular from 'angular';

class ModalAddUserAuthorizationCtrl {
    /* @ngInject */
    constructor($translate, LegalEntityGroupUser, logger) {
        this.$translate = $translate;
        this.LegalEntityGroupUser = LegalEntityGroupUser;
        this.logger = logger;
    }

    $onInit() {
        var ctrl = this;
        ctrl.selectedProfile = null;
        ctrl.authorization = new this.LegalEntityGroupUser();
        ctrl.legalEntityGroups = this.resolve.groups;
        ctrl.wkfProfiles = this.resolve.wkfProfiles;
        ctrl.principal = this.resolve.principal;
        ctrl.mustBeAdminFo = this.resolve.mustBeAdminFo;
        ctrl.currentProfiles = this.resolve.profiles;
        ctrl.profiles = this.getProfiles(ctrl.principal.id, ctrl.currentProfiles);
        if (ctrl.legalEntityGroups.length === 1) {
            ctrl.authorization.legalEntityGroup = ctrl.legalEntityGroups[0];
        }
        if (ctrl.mustBeAdminFo) {
            ctrl.selectedProfile = ctrl.profiles.find(p => p.role === 'ADMIN_FO');
        } else if (!ctrl.principal.detail.processO2c) {
            ctrl.selectedProfile = ctrl.profiles.find(p => p.role === 'SUPPLIER_ACCOUNTANT');
        } else if (!ctrl.principal.detail.processP2p) {
            ctrl.selectedProfile = ctrl.profiles.find(p => p.role === 'CUSTOMER_ACCOUNTANT');
        } else if (!ctrl.principal.detail.profilSellerInvited) {
            ctrl.selectedProfile = ctrl.profiles.find(p => p.role === 'ACCOUNTANT');
        }
        this.onProfileChange();
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    confirm() {
        if (!this.authorization.legalEntityGroup) {
            this.logger.error(this.$translate.instant('error.missing_authorisation_group'));
            return;
        }
        if (!this.selectedProfile) {
            this.logger.error(this.$translate.instant('error.missing_authorisation_role'));
            return;
        }
        this.authorization.role = this.selectedProfile.role;
        this.authorization.wkfProfile = this.selectedProfile.code;
        this.authorization.wkfScope = this.selectedProfile.workflowScope;
        this.authorization.type = this.selectedProfile.type;
        this.modalInstance.close(this.authorization);
    }

    onProfileChange() {
        if (this.selectedRoleIsAdminFo() || this.selectedRoleIsAdminGed()) {
            this.authorization.legalEntityGroup = this.legalEntityGroups[0];
        }
        if (this.isBadSalesAdminGroupConsistency()) {
            this.authorization.legalEntityGroup = null;
        }
    }

    selectedRoleIsAdminGed() {
        return this.selectedProfile && this.selectedProfile.role === 'ADMIN_GED';
    }

    onGroupChange() {
        if (this.isBadSalesAdminGroupConsistency()) {
            this.selectedProfile = null;
        }
    }

    // cohérence entre le role sales Admin et le group
    //seul un group par défaut ou un group de sociétés qui peut avoir le role
    isBadSalesAdminGroupConsistency() {
        return (
            this.selectedRoleIsSalesAdmin() &&
            this.authorization.legalEntityGroup &&
            this.authorization.legalEntityGroup.type !== 'STANDARD' &&
            this.authorization.legalEntityGroup.type !== 'ALL'
        );
    }

    selectedRoleIsAdminFo() {
        return this.selectedProfile && this.selectedProfile.role === 'ADMIN_FO';
    }

    selectedRoleIsSalesAdmin() {
        return this.selectedProfile && this.selectedProfile.role === 'SALES_ADMIN';
    }
    getProfiles() {
        const profiles = [];
        if (this.principal.detail.processO2c) {
            profiles.push({
                role: 'CUSTOMER_ACCOUNTANT',
                label: this.$translate.instant('kiss_user.profil.customer_accountant'),
            });
            if (this.resolve.canHaveSalesAdmin) {
                profiles.push({
                    role: 'SALES_ADMIN',
                    label: this.$translate.instant('kiss_user.profil.sales_admin'),
                });
            }
        }
        if (this.principal.detail.processP2p) {
            profiles.push({
                role: 'SUPPLIER_ACCOUNTANT',
                label: this.$translate.instant('kiss_user.profil.supplier_accountant'),
            });
        }
        if (this.principal.detail.profilSellerInvited) {
            profiles.push({
                role: 'EXECUTIVE',
                label: this.$translate.instant('kiss_user.profil.executive'),
            });
            //si l'utilisateur a le profil admin alors on ne peut pas lui proposer le profil responsable
            if (!this.currentProfiles.find(p => p.role === 'ADMIN_FO')) {
                profiles.push({
                    role: 'ACCOUNTANT',
                    label: this.$translate.instant('kiss_user.profil.accountant'),
                });
            }
        }
        if (this.principal.detail.threeWayMatching) {
            this.wkfProfiles.forEach(p => {
                profiles.push(p);
            });
        }
        //si l'utilisateur a le profil responsable alors on ne peut pas lui proposer le profil admin
        if (!this.currentProfiles.find(p => p.role === 'ACCOUNTANT')) {
            profiles.push({
                role: 'ADMIN_FO',
                label: this.$translate.instant('kiss_user.profil.admin_fo'),
            });
        }
        if (this.isDocumentarySpace()) {
            profiles.push({
                role: 'ADMIN_GED',
                label: this.$translate.instant('kiss_user.profil.admin_ged'),
            });
            profiles.push({
                role: 'USER_GED',
                label: this.$translate.instant('kiss_user.profil.user_ged'),
            });
        }

        return profiles;
    }

    isDocumentarySpace() {
        return this.principal.detail.hasDocumentarySpace;
    }
}

angular.module('app.principal').component('modalAddUserAuthorization', {
    templateUrl: require('./modal-add-user-authorization.html'),
    controller: ModalAddUserAuthorizationCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
        mustBeAdminFo: '<',
    },
});
